import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { Subject, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-transcodifica',
	templateUrl: './transcodifica.component.html',
})
export class TranscodificaComponent implements OnInit, OnDestroy {
	constructor(
		private api: ApiService,
		private modalService: NgbModal,
	) {}

	transcodifiche = [];
	transcodificaSelected: any = {};

	dtTrigger: Subject<any> = new Subject<any>();

	ngOnInit() {
		this.api.getTranscodificheCliente().subscribe((res) => {
			this.transcodifiche = res;
			this.dtTrigger.next();
		});
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	apriModaleDettaglio(content, transcodifica = {}) {
		this.transcodificaSelected = JSON.parse(JSON.stringify(transcodifica));
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
	}

	salva(modal) {
		this.api.saveTranscodificaCliente(this.transcodificaSelected).subscribe((res) => {
			if (res) {
				this.api.getTranscodificheCliente().subscribe((transcodifiche) => (this.transcodifiche = transcodifiche));
				modal.close();
			} else {
				alert('Errore durante il salvataggio della transcodifica');
			}
		});
	}
}
